import { render } from "./contactComponent.vue?vue&type=template&id=2db3e68c&scoped=true"
import script from "./contactComponent.vue?vue&type=script&lang=js"
export * from "./contactComponent.vue?vue&type=script&lang=js"

import "./contactComponent.vue?vue&type=style&index=0&id=2db3e68c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db3e68c"]])

export default __exports__